module.exports = __webpack_public_path__ + "static/fb-f5681b024c80fb8d7dec85b599f3202a.jpeg";